/**
 * Superintendent Command Center
 *
 * Custom 3-column layout without AppShell to avoid layout conflicts
 */
import {
  Badge,
  Button,
  Card,
  Group,
  Stack,
  Text,
  Progress,
  Indicator,
} from '@mantine/core';
import TopNav from '../components/TopNav';

export default function SuperintendentCommandCenter() {
  const today = new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      background: '#f8f9fa'
    }}>
      {/* Top Navigation */}
      <TopNav />

      {/* Content area with 3-column layout */}
      <div style={{
        flex: 1,
        display: 'grid',
        gridTemplateColumns: '280px 1fr 320px',
        overflow: 'hidden'
      }}>
        {/* Left Navbar - Priority Queue */}
        <div style={{
        background: 'white',
        borderRight: '1px solid #dee2e6',
        overflowY: 'auto',
        padding: 16
      }}>
        <Stack gap="md">
          <Text size="md" fw={600}>Priority Decisions</Text>

          <Card padding="sm" withBorder style={{ cursor: 'pointer' }}>
            <Group justify="space-between" mb={4}>
              <Badge color="red" size="sm">CRITICAL</Badge>
              <Text size="xs" c="dimmed">2h ago</Text>
            </Group>
            <Text size="sm" fw={600} mb={4}>Bank X Capital Ratio Alert</Text>
            <Text size="xs" c="dimmed">Requires immediate intervention</Text>
          </Card>

          <Card padding="sm" withBorder style={{ cursor: 'pointer' }}>
            <Group justify="space-between" mb={4}>
              <Badge color="orange" size="sm">HIGH</Badge>
              <Text size="xs" c="dimmed">4h ago</Text>
            </Group>
            <Text size="sm" fw={600} mb={4}>E-23 Compliance Review</Text>
            <Text size="xs" c="dimmed">3 FIs pending model approval</Text>
          </Card>

          <Card padding="sm" withBorder style={{ cursor: 'pointer' }}>
            <Group justify="space-between" mb={4}>
              <Badge color="blue" size="sm">NORMAL</Badge>
              <Text size="xs" c="dimmed">1d ago</Text>
            </Group>
            <Text size="sm" fw={600} mb={4}>Q3 Supervisory Report</Text>
            <Text size="xs" c="dimmed">Ready for final review</Text>
          </Card>

          <Text size="md" fw={600} mt="lg">Today • {today}</Text>

          <Stack gap="xs">
            <Group gap="sm" wrap="nowrap">
              <div style={{ textAlign: 'right', minWidth: 45 }}>
                <Text size="sm" fw={600} lh={1.2}>9:00</Text>
                <Text size="xs" c="dimmed">1h</Text>
              </div>
              <div style={{ flex: 1 }}>
                <Text size="sm" fw={600} lh={1.2}>Executive Committee</Text>
                <Text size="xs" c="dimmed">Board Room • 8 attendees</Text>
              </div>
            </Group>

            <Group gap="sm" wrap="nowrap">
              <div style={{ textAlign: 'right', minWidth: 45 }}>
                <Text size="sm" fw={600} lh={1.2}>10:30</Text>
                <Text size="xs" c="dimmed">30m</Text>
              </div>
              <div style={{ flex: 1 }}>
                <Text size="sm" fw={600} lh={1.2}>Minister Briefing</Text>
                <Text size="xs" c="dimmed">Virtual • Quarterly update</Text>
              </div>
            </Group>

            <div style={{
              background: '#e7f5ff',
              borderLeft: '3px solid #228be6',
              padding: '8px',
              borderRadius: 4,
              marginLeft: -3
            }}>
              <Group gap="sm" wrap="nowrap">
                <div style={{ textAlign: 'right', minWidth: 45 }}>
                  <Text size="sm" fw={600} lh={1.2}>14:00</Text>
                  <Text size="xs" c="dimmed">90m</Text>
                </div>
                <div style={{ flex: 1 }}>
                  <Text size="sm" fw={600} lh={1.2}>Bank CEOs Roundtable</Text>
                  <Text size="xs" c="dimmed">Conference A • E-23 discussion</Text>
                </div>
              </Group>
            </div>

            <Group gap="sm" wrap="nowrap">
              <div style={{ textAlign: 'right', minWidth: 45 }}>
                <Text size="sm" fw={600} lh={1.2}>16:00</Text>
                <Text size="xs" c="dimmed">45m</Text>
              </div>
              <div style={{ flex: 1 }}>
                <Text size="sm" fw={600} lh={1.2}>Risk Review</Text>
                <Text size="xs" c="dimmed">Office • Q3 assessment</Text>
              </div>
            </Group>
          </Stack>

          <Text size="md" fw={600} mt="lg">Leadership</Text>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <Group gap={6} style={{ background: '#f8f9fa', padding: '6px 8px', borderRadius: 4 }}>
              <Indicator color="green" size={8} />
              <Text size="xs" fw={600} style={{ flex: 1 }}>J. Rudin</Text>
              <Text size="xs" c="dimmed">Deputy</Text>
            </Group>
            <Group gap={6} style={{ background: '#f8f9fa', padding: '6px 8px', borderRadius: 4 }}>
              <Indicator color="orange" size={8} />
              <Text size="xs" fw={600} style={{ flex: 1 }}>S. Saldaris</Text>
              <Text size="xs" c="dimmed">CFO</Text>
            </Group>
            <Group gap={6} style={{ background: '#f8f9fa', padding: '6px 8px', borderRadius: 4 }}>
              <Indicator color="green" size={8} />
              <Text size="xs" fw={600} style={{ flex: 1 }}>R. Mizdrak</Text>
              <Text size="xs" c="dimmed">Risk</Text>
            </Group>
            <Group gap={6} style={{ background: '#f8f9fa', padding: '6px 8px', borderRadius: 4 }}>
              <Indicator color="gray" size={8} />
              <Text size="xs" fw={600} style={{ flex: 1 }}>A. Miller</Text>
              <Text size="xs" c="dimmed">CDO</Text>
            </Group>
          </div>
        </Stack>
      </div>

        {/* Main Content */}
        <div style={{
          overflowY: 'auto',
          padding: 16
        }}>
        <Stack gap="md">
          {/* Stats Grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: 12
          }}>
            <Card withBorder padding="md">
              <Text size="xs" tt="uppercase" c="dimmed" mb="xs">System Risk Level</Text>
              <Text size="xl" fw={700} c="orange" mb="xs">MODERATE</Text>
              <Text size="xs" c="green">↓ 2% from last month</Text>
            </Card>
            <Card withBorder padding="md">
              <Text size="xs" tt="uppercase" c="dimmed" mb="xs">Active FIs</Text>
              <Text size="xl" fw={700} mb="xs">423</Text>
              <Text size="xs" c="dimmed">100% reporting current</Text>
            </Card>
            <Card withBorder padding="md">
              <Text size="xs" tt="uppercase" c="dimmed" mb="xs">E-23 Readiness</Text>
              <Text size="xl" fw={700} mb="xs">67%</Text>
              <Text size="xs" c="dimmed">18 months to deadline</Text>
            </Card>
            <Card withBorder padding="md">
              <Text size="xs" tt="uppercase" c="dimmed" mb="xs">Capital Adequacy</Text>
              <Text size="xl" fw={700} mb="xs">12.8%</Text>
              <Text size="xs" c="green">↑ 0.3% this quarter</Text>
            </Card>
          </div>

          {/* Decision Cards */}
          <Text size="md" fw={600}>Pending Decisions</Text>

          <Card withBorder padding="md">
            <Group justify="space-between" mb="sm">
              <div>
                <Text size="sm" fw={600} mb={4}>Capital Relief Request - Bank X</Text>
                <Text size="xs" c="dimmed">Submitted 2 hours ago by Supervision Sector 1</Text>
              </div>
              <Badge color="red">CRITICAL</Badge>
            </Group>
            <Text size="sm" mb="md">
              Bank X requests temporary capital relief due to market volatility.
              Current ratio: 10.2% (min: 10.5%). Risk assessment complete.
            </Text>
            <Group gap="sm">
              <Button size="sm">Approve with Conditions</Button>
              <Button size="sm" variant="outline">Request More Info</Button>
              <Button size="sm" variant="light">Deny</Button>
            </Group>
          </Card>

          <Card withBorder padding="md">
            <Group justify="space-between" mb="sm">
              <div>
                <Text size="sm" fw={600} mb={4}>Model Approval - Insurance Co Y</Text>
                <Text size="xs" c="dimmed">E-23 Compliance Review - Due in 3 days</Text>
              </div>
              <Badge color="orange">HIGH</Badge>
            </Group>
            <Text size="sm" mb="md">
              Internal model validation complete. Meets 2/3 E-23 principles.
              Explainability score: 72%. Technical review attached.
            </Text>
            <Group gap="sm">
              <Button size="sm">Approve</Button>
              <Button size="sm" variant="outline">Conditional Approval</Button>
              <Button size="sm" variant="light">Review Details</Button>
            </Group>
          </Card>

          {/* Communications */}
          <Text size="md" fw={600}>Recent Communications</Text>

          <Card withBorder padding="md">
            <Group justify="space-between" mb="sm">
              <Text size="sm" fw={600}>To: Finance Minister</Text>
              <Text size="xs" c="dimmed">Sent 1h ago</Text>
            </Group>
            <Text size="sm">Q3 Financial Stability Report - System remains resilient</Text>
          </Card>

          <Card withBorder padding="md">
            <Group justify="space-between" mb="sm">
              <Text size="sm" fw={600}>To: Bank CEOs</Text>
              <Text size="xs" c="dimmed">Scheduled 14:00</Text>
            </Group>
            <Text size="sm">Monthly roundtable on E-23 implementation progress</Text>
          </Card>
        </Stack>
      </div>

        {/* Right Aside - Intelligence */}
        <div style={{
          background: 'white',
          borderLeft: '1px solid #dee2e6',
          overflowY: 'auto',
          padding: 16
        }}>
        <Stack gap="md">
          <Text size="md" fw={600}>Intelligence Alerts</Text>

          <Card padding="sm" style={{ borderLeft: '3px solid #fd7e14' }}>
            <Text size="sm" fw={600} mb={4}>Market Volatility</Text>
            <Text size="xs" c="dimmed" lh={1.4}>
              TSX down 3.2%. Banking sector showing stress signals.
              2 mid-size banks approaching threshold ratios.
            </Text>
          </Card>

          <Card padding="sm" style={{ borderLeft: '3px solid #fd7e14' }}>
            <Text size="sm" fw={600} mb={4}>Regulatory Update</Text>
            <Text size="xs" c="dimmed" lh={1.4}>
              Basel IV implementation delayed by 6 months globally.
              Impact assessment required.
            </Text>
          </Card>

          <Text size="md" fw={600} mt="lg">Organization Health</Text>

          <Card withBorder padding="sm">
            <Group justify="space-between" mb="xs">
              <Text size="xs">Staff Capacity</Text>
              <Text size="xs">87%</Text>
            </Group>
            <Progress value={87} size="sm" />
          </Card>

          <Card withBorder padding="sm">
            <Group justify="space-between" mb="xs">
              <Text size="xs">Review Backlog</Text>
              <Text size="xs">12 items</Text>
            </Group>
            <Progress value={24} size="sm" color="orange" />
          </Card>

          <Card withBorder padding="sm">
            <Group justify="space-between" mb="xs">
              <Text size="xs">AI Tool Adoption</Text>
              <Text size="xs">34%</Text>
            </Group>
            <Progress value={34} size="sm" color="green" />
          </Card>

          <Text size="md" fw={600} mt="lg">Vision 2030 Progress</Text>

          <Card withBorder padding="sm">
            <Text size="sm" fw={600} mb="sm">Q3 Milestones</Text>
            <Text size="xs" c="dimmed" mb="xs">✓ DCM Platform Live</Text>
            <Text size="xs" c="dimmed" mb="xs">✓ AI CoE Established</Text>
            <Text size="xs" c="dimmed" mb="xs">→ SupTech Tool Rollout (45%)</Text>
            <Text size="xs" c="dimmed">→ Staff Training (67%)</Text>
          </Card>
          </Stack>
        </div>
      </div>
    </div>
  );
}
